import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import {
  fetchNwmlsDetail,
  fetchNwmlsDetailFailure,
  fetchNwmlsDetailSuccess,
  fetchNwmlsList,
  fetchNwmlsListFailure,
  fetchNwmlsListSuccess,
} from './nwmls.action';

@Injectable()
export class NwmlsEffects {
  constructor(private actions$: Actions, private CrudService: CrudService) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchNwmlsList),
      mergeMap((action) =>
        this.CrudService.postData('Admin/Mls/SearchProperty',action.payload).pipe(
          map((result) => fetchNwmlsListSuccess({ response: result })),

          catchError((error) => of(fetchNwmlsListFailure({ error })))
        )
      )
    )
  );

  fetchDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchNwmlsDetail),
      mergeMap((action) =>
        this.CrudService.getData('Admin/Mls/' + action.payload.id).pipe(
          map((result) => fetchNwmlsDetailSuccess({ response: result })),

          catchError((error) => of(fetchNwmlsDetailFailure({ error })))
        )
      )
    )
  );
}
